import { useRef } from 'react';

// Custom hooks to scroll to top. Return an array of ref and scroll to ref function.
export const useScrollToTop = props => {
  const scrollUpRef = useRef();
  const scrollToRef = () => scrollUpRef.current.scrollIntoView(props);

  return [scrollUpRef, scrollToRef];
};
